import { UploadSourcemapsCommand } from "@apm-insight-web/upload-sourcemaps";
import * as path from "path";
import * as fs from "fs";

interface Options {
  paths?: string[];
  app_id: string | number;
  host?: string;
  env?: string;
  release?: string;
  appSecret: string;
  appKey: string;
}

// 添加延迟函数
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
// 添加执行状态跟踪，避免重复执行
let hasRun = false;

export const uploadSourcemapsPlugin = function (options: Options): any {
  return {
    name: "vite-upload-sourcemaps-plugin",
    apply: "build",
    // 改为writeBundle钩子，它会在文件写入后执行
    writeBundle: async () => {

      if (hasRun) {
        console.log('SourceMap上传插件已执行过，跳过重复执行');
        return;
      }
      hasRun = true;
      // 给Nuxt一些时间完成目录创建
      // console.log('等待Nuxt完成目录创建...', UploadSourcemapsCommand);
      await delay(5000); // 等待5秒

      // console.log('开始执行sourcemap上传插件...');
      let { paths } = options;
      const { host, env, release, app_id, appSecret, appKey } = options;

      // 获取项目根目录的绝对路径
      const rootDir = process.cwd();
      // console.log('当前工作目录:', rootDir);

      if (!paths || !Array.isArray(paths) || !paths.length) {
        // 使用绝对路径
        paths = [
          path.resolve(rootDir, '.output/public/_nuxt'),  // Nuxt 3标准路径
          // path.resolve(rootDir, 'dist/_nuxt'),            // 某些配置下的路径
        ];
      } else {
        // 将相对路径转为绝对路径
        paths = paths.map(p => path.isAbsolute(p) ? p : path.resolve(rootDir, p));
      }

      // console.log('将检查以下路径:', paths);

      // 过滤出实际存在的路径
      const existingPaths = paths.filter(dirPath => {
        const exists = fs.existsSync(dirPath);
        // console.log(`检查路径 ${dirPath}: ${exists ? '存在' : '不存在'}`);
        return exists;
      });

      if (existingPaths.length === 0) {
        // console.log('没有找到有效的sourcemap目录，跳过上传');
        return;
      }

      // 检查目录中是否有map文件
      const pathsWithMaps = [];
      for (const dirPath of existingPaths) {
        try {
          let hasMapFiles = false;
          const checkDir = (currentPath: any) => {
            if (!fs.existsSync(currentPath)) return;

            const files = fs.readdirSync(currentPath);
            for (const file of files) {
              const filePath = path.join(currentPath, file);
              const stat = fs.statSync(filePath);

              if (stat.isDirectory()) {
                checkDir(filePath);
              } else if (file.endsWith('.map')) {
                hasMapFiles = true;
                console.log(`找到map文件: ${filePath}`);
              }
            }
          };

          checkDir(dirPath);
          if (hasMapFiles) {
            pathsWithMaps.push(dirPath);
          } else {
            console.log(`目录 ${dirPath} 中没有找到.map文件`);
          }
        } catch (err) {
          console.error(`检查目录 ${dirPath} 出错:`, err);
        }
      }

      if (pathsWithMaps.length === 0) {
        console.log('没有找到包含.map文件的目录，跳过上传');
        return;
      }

      try {
        console.log("开始上传sourcemaps，使用路径:", pathsWithMaps);
        await UploadSourcemapsCommand.upload({
          paths: pathsWithMaps,
          app_id,
          host,
          env,
          release,
          appSecret,
          appKey,
        });
        console.log("上传sourcemaps成功", pathsWithMaps);

        // 删除map文件
        const deleteMapFiles = (dirPath: string) => {
          if (!fs.existsSync(dirPath)) return;

          fs.readdirSync(dirPath).forEach((file: string) => {
            const filePath = path.join(dirPath, file);

            try {
              const stat = fs.statSync(filePath);
              if (stat.isDirectory()) {
                deleteMapFiles(filePath);
              } else if (path.extname(file) === ".map") {
                fs.unlinkSync(filePath);
                console.log(`已删除: ${filePath}`);
              }
            } catch (err) {
              console.error(`处理文件 ${filePath} 时出错:`, err);
            }
          });
        };

        pathsWithMaps.forEach((dirPath) => deleteMapFiles(dirPath));
        console.log("删除sourcemaps成功");
      } catch (e) {
        console.error('上传sourcemap失败:', e);
      }
    },
  };
};